import { TagSimple } from "@phosphor-icons/react";
import { DatabaseFileLabel, PickerItemProps } from "../../types";
import { getFileLabelStyling, getResourceTypeLabel } from "../../utils/fileLabelUtils";

export const FileLabelItem = ({ item, onSelect }: PickerItemProps<DatabaseFileLabel>) => {
  const styling = getFileLabelStyling(item);

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors border ${styling.bgColor} ${styling.borderColor}`}
    >
      <div className="flex items-center gap-2">
        <TagSimple className={`h-4 w-4 ${styling.iconColor}`} />
        <div>
          <div className={`font-medium ${styling.textColor}`}>{item.label}</div>
          <div className="text-xs text-neutral-secondary-mid">
            {item.resourceType && (
              <>
                <span className={styling.textColor}>
                  {getResourceTypeLabel(item.resourceType)}
                </span>
                {item.documentType && (
                  <span> • {item.documentType}</span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};